<template>
<div class="page_sublink">
  <ul class="recruit2021_page_sublink" v-if="this.recruit_check()">
    <li><router-link v-bind:to="{name:'program_index', params : { link: true }}" exact>番組制作</router-link></li>
    <li><router-link v-bind:to="{name:'vp_cm_index', params : { link: true }}">動画制作</router-link></li>
    <li><router-link v-bind:to="{name:'event_index', params : { link: true }}">イベント</router-link></li>
    <li><router-link v-bind:to="{name:'drawn_index', params : { link: true }}">ドローン事業</router-link></li>
    <li><router-link v-bind:to="{name:'photographing_index', params : { link: true }}" class="pd_23px">撮影・編集</router-link></li>
    <li><router-link v-bind:to="{name:'video-archive_index', params : { link: true }}">テレビ朝日映像<br />アーカイブ</router-link></li>
  </ul>
  <ul v-else>
    <li><router-link v-bind:to="{name:'program_index'}" exact>番組制作</router-link></li>
    <li><router-link v-bind:to="{name:'vp_cm_index'}">動画制作</router-link></li>
    <li><router-link v-bind:to="{name:'magic_index'}">マジック</router-link></li>
    <li><router-link v-bind:to="{name:'event_index'}">イベント</router-link></li>
    <li><router-link v-bind:to="{name:'drawn_index'}">ドローン事業</router-link></li>
    <li><router-link v-bind:to="{name:'photographing_index'}">撮影・編集</router-link></li>
    <li><router-link v-bind:to="{name:'video-archive_index'}">テレビ朝日映像アーカイブ</router-link></li>
  </ul>
</div><!-- .page_sublink -->
</template>

<script>
export default {
  name: 'works_page_nav',
  methods: {
    recruit_check(){
      return ['recruit_2021','recruit_2022','recruit_2023','recruit_2024'].includes(this.$route.name)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/worksPageNav.vue